import React, { useContext, useEffect, useMemo, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import Select from "components/common/Select";
import FormAdvancedOptions from "./FormAdvancedOptions";
import INITIAL_FORMDATA from "./_initialFormData";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  var _a, _b, _c;
  const { formData, setFormData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { pollingInterval } = formData;
  const availableContent = [
    { label: "Email Logs", value: "EMAIL_LOGS" },
    { label: "Directory Audit Logs", value: "DIRECTORY_AUDIT_LOGS" },
    { label: "SignIn Audit Logs", value: "SIGN_IN_AUDIT_LOGS" },
    { label: "Provisioning Audit Logs", value: "PROVISIONING_AUDIT_LOGS" },
    { label: "Security Alerts V2 Logs", value: "SECURITY_ALERTS_V2_LOGS" },
    { label: "Security Incidents Logs", value: "SECURITY_INCIDENTS_LOGS" }
  ];
  const subscriptionType = (_a = formData.subscriptionType) == null ? void 0 : _a.value;
  const defaultContentTypes = useMemo(() => {
    if (subscriptionType !== "GLOBAL") {
      return INITIAL_FORMDATA.availableContents.value.split(",").filter((x) => x !== "SIGN_IN_AUDIT_LOGS").join(",");
    }
    return INITIAL_FORMDATA.availableContents.value;
  }, [subscriptionType]);
  const contentTypes = ((_b = formData.content_type) == null ? void 0 : _b.value) || defaultContentTypes;
  useEffect(() => {
    var _a2;
    if (!((_a2 = formData.content_type) == null ? void 0 : _a2.value)) {
      setFormData("content_type", { value: defaultContentTypes });
    }
  }, [defaultContentTypes, (_c = formData.content_type) == null ? void 0 : _c.value, setFormData]);
  const handleSubmit = () => {
    let error = false;
    if (pollingInterval.value < 1) {
      setFormError({
        full_message: "Please provide valid polling interval",
        nice_message: "Minimum allowable polling interval is 1 minute."
      });
      error = true;
    }
    if (!error) {
      setFormError(null);
      setFormData("content_type", { value: contentTypes });
      onSubmit();
    }
  };
  const handleReadTimeOffsetChange = (errorMessage) => {
    if (errorMessage) {
      setFormError({
        full_message: errorMessage,
        nice_message: errorMessage
      });
    } else {
      setFormError(null);
    }
  };
  return /* @__PURE__ */ React.createElement(FormWrap, { onSubmit: handleSubmit, buttonContent: "Proceed", title: "", error: formError, description: "" }, /* @__PURE__ */ React.createElement("label", { className: "control-label", htmlFor: "contents" }, "Logs Types to Collect"), /* @__PURE__ */ React.createElement(
    Select,
    {
      multi: true,
      name: "content_type",
      id: "content_type",
      onChange: (selected) => setFormData("content_type", { value: selected }),
      options: availableContent,
      value: contentTypes
    }
  ), /* @__PURE__ */ React.createElement("span", { className: "help-block" }, "The activity log for the above content types will be fetched."), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "pollingInterval",
      name: "pollingInterval",
      type: "number",
      value: pollingInterval.value || pollingInterval.defaultValue || "",
      min: "1",
      max: "60",
      step: "1",
      onChange,
      required: true,
      help: "Determines how often (in minutes) the input will check for new data from Microsoft Graph API. The smallest allowable interval is 1 minute.",
      label: "Polling Interval"
    }
  ), /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange, handleReadTimeOffsetChange }));
};
export default StepSubscribe;
